import { Injectable } from '@angular/core';
import { ApiClientService } from 'projects/dnest-core-angular/src/public-api';
import { User } from 'src/app/models/user';

@Injectable({
  providedIn: 'root'
})
export class KamUserApiClientService extends ApiClientService<User> {
  endpoint = 'user';
}

